import { useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";


const PaymentForm = () => {
  const user = useSelector((state) => state.auth.user);
  console.log("User in PaymentForm:", user);
  const loggedInBusinessId = user?.businessId || null;
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
 
  const { eventId, businessId, plan, subscriptionPayment, isYearly } = location.state || {};

  const PAYMENT_SUCCESS_URL = `https://beta.boothbloom.com/client-home?businessId=${businessId}`;


  const UPDATE_PAYMENT_API_URL = `${process.env.REACT_APP_API_URL}/events/update-payment-status`;


  const updateSubscription = async () => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/update-subscription`,
      { planName: plan?.name, planId:plan?._id, isYearly: isYearly},
      { withCredentials: true }
    );

    alert("Plan updated succesfully. Kindly Login")
    return response.data;
  } catch (error) {
    console.error("Error updating subscription:", error.response?.data || error.message);
    throw error;
  }
};



 const generateBusinessInvoice = async () => {
  console.log('Generating invoice for businessId:', loggedInBusinessId);
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/businesss/generate-invoice`,
      {businessId: loggedInBusinessId},
      {
        withCredentials: true,
      }
    );

    console.log('Invoice generated:', response.data);
  } catch (error) {
    console.error(
      'Invoice generation failed:',
      error.response?.data?.error || error.message
    );
  }
};



  
  const generateInvoice = async () => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/event/generate-invoice`,
      {eventId},
      { withCredentials: true }
    );

  } catch (error) {
    console.error("Error updating subscription:", error.response?.data || error.message);
    throw error;
  }
};


  const updatePaymentStatus = async (eventId) => {
    try {
      const response = await axios.post(
        UPDATE_PAYMENT_API_URL,
        { eventId, payment: "paid" },
        { withCredentials: true }
      );
    } catch (error) {
      console.error("Failed to update payment status:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
  
    setIsLoading(true);
    setMessage("Payment in Progress");
  
    try {
      const resp = await stripe.confirmPayment({
        elements,
        redirect: 'if_required',
      });
  
      if (resp.error) {
        console.error("Stripe Error:", resp.error.message);
        setMessage("Some Error Occurred !!");
      } else if (resp.paymentIntent?.status === "succeeded") {
        console.log("Payment succeeded, updating payment status");

        if (subscriptionPayment) {
          await updateSubscription();
          await generateBusinessInvoice(businessId);
          console.log(loggedInBusinessId, "loggedInBusinessId");
          // Reset subscriptionPayment flag in the state by replacing history entry
          navigate('/login', { replace: true, state: { ...location.state, subscriptionPayment: false } });
          return;
        }

        await updatePaymentStatus(eventId);
        await generateInvoice();
  
        // Redirect manually
        window.location.href = PAYMENT_SUCCESS_URL;
      }
    } catch (error) {
      console.error("Payment submission error:", error);
      setMessage("Payment process failed!");
    }
  
    setIsLoading(false);
  };
 
    return (
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <form onSubmit={handleSubmit}>
                <div style={{ width: '100%', backgroundColor: '#e5e7eb', boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1)', borderRadius: '0.5rem' }}>
                    <div style={{ padding: '1.5rem' }}>
                        <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem', textAlign: 'center' }}>
                            Complete your payment here!
                        </h1>
                        <PaymentElement />
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1.5rem' }}>
                            <button
                                style={{
                                    padding: '0.5rem 1rem',
                                    backgroundColor: '#3b82f6',
                                    borderRadius: '0.75rem',
                                    color: '#fff',
                                    textAlign: 'center',
                                    border: 'none',
                                    cursor: 'pointer'
                                }}
                                disabled={isLoading || !stripe || !elements}
                            >
                                {isLoading ? "Loading..." : "Pay now"}
                            </button>
                        </div>
                        {message && <div>{message}</div>}
                    </div>
                </div>
            </form>
        </div>
    );
};
 
export default PaymentForm;
